import { render, staticRenderFns } from "./dropdown_widget.vue?vue&type=template&id=55a3e62e&scoped=true"
import script from "./dropdown_widget.vue?vue&type=script&lang=js"
export * from "./dropdown_widget.vue?vue&type=script&lang=js"
import style0 from "./dropdown_widget.vue?vue&type=style&index=0&id=55a3e62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3e62e",
  null
  
)

export default component.exports